import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<footer
    class="min-h-16 w-full bg-[#0073cf] px-6 text-sm"
    role="presentation"
  ></footer>`,
})
export class FooterComponent {}
